import styled from 'styled-components';
import { Constants } from '@shared/ui-components';

export const PAGE_HEADER_HEIGHT = 90;

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: ${PAGE_HEADER_HEIGHT}px;
  width: 100%;
  background-color: ${p => p.theme.color.backgroundRush};

  .page-header__logo {
    display: flex;
    padding: 24px 30px;

    svg {
      width: 40px;
      height: 40px;
      transform: rotate(180deg);
    }
  }
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-height: 100%;
  margin-left: auto;
  min-width: 0;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-height: 100%;
  min-width: 0;
`;

const UserMenu = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-height: 100%;
  margin-right: 25px;
  margin-left: auto;
`;

const ProjectMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 80px;
  position: relative;
  margin-right: 15px;
  *, & {
    box-sizing: border-box;
  }
`;

const ProjectMenu = styled.div`
  z-index: 6;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  width: 220px;
  padding: 20px;
  border-radius: 15px;
  background: ${p => p.theme.color.backgroundRush};
  border: 1px solid ${p => p.theme.color.background};
  transform-origin: left top;
  animation: ${Constants.Animations.appearAnimation} ${p => p.theme.duration.m} ease-in-out;
`;

const ProjectMenuDate = styled.div`
  display: flex;
  align-items: center;
  svg {
    height: 20px;
    fill: ${p => p.theme.color.gray};
    margin-right: 10px;
  }
`;

const ProjectMenuUsers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AddUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  background-color: ${p => p.theme.color.turquoise};
  border-radius: 10px;
  cursor: pointer;
  svg {
    height: 20px;
    fill: ${p => p.theme.color.white};
  }
`;

export const Styled = {
  Container,
  RightSide,
  UserMenu,
  Content,
  ProjectMenuContainer,
  ProjectMenu,
  ProjectMenuDate,
  ProjectMenuUsers,
  AddUser,
};
